import {
  Box,
  Typography,
  Button,
  Paper,
  Grid,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
} from "@mui/material";
import React, { useContext, useState, useEffect } from "react";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import { ViewState } from "@devexpress/dx-react-scheduler";
import {
  Scheduler,
  MonthView,
  Appointments,
  DateNavigator,
  Toolbar,
} from "@devexpress/dx-react-scheduler-material-ui";
import SquareIcon from "@mui/icons-material/Square";
import HomeFrame from "../Components/HomeFrame";
import Footer from "../Components/Footer";
import "../CSS/GetHelp.css";
import { backendCall } from "../utils/Network";
import { GlobalContext } from "../utils/GlobalContext";

export default function Appointment() {
  const { setGlobalMessage } = useContext(GlobalContext);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [org, setOrg] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [open, setOpen] = useState(false);
  const [appData, setAppData] = useState();
  const [appointments, setAppointment] = useState([]);

  useEffect(() => {
    const fetchAppointments = async () => {
      const response = await backendCall.get("/technical_assistance_session");
      setAppointment(
        response.data.map((app) => {
          return {
            title: "Techinical Assistance",
            startDate: new Date(app.start_time),
            endDate: new Date(app.end_time),
            id: app.session_id,
            disabled: app.is_reserved,
          };
        })
      );
    };
    fetchAppointments();
  }, []);

  const Appointment = ({ children, data, style, ...restProps }) => (
    <Appointments.Appointment
      {...restProps}
      style={{
        ...style,
        backgroundColor: !data.disabled ? "#223870" : "#c4c2c2",
      }}
      onClick={() => {
        if (!data.disabled) {
          setAppData(data);
          setOpen(true);
        }
      }}
    >
      {children}
      <Typography
        color="white"
        fontSize={11}
        sx={{ pl: "6px", position: "relative" }}
      >
        <Box
          sx={{
            position: "absolute",
            top: -10,
            left: "5%",
            zIndex: "modal",
          }}
        >
          {to12HourFormat(data.startDate) +
            " ~ " +
            to12HourFormat(data.endDate)}
        </Box>
      </Typography>
    </Appointments.Appointment>
  );

  const closeRevervation = () => {
    setOpen(false);
  };

  const to12HourFormat = (date) => {
    var hours = date?.getUTCHours();
    var minutes = date?.getUTCMinutes();

    var newFormat = hours >= 12 ? "PM" : "AM";
    hours = hours <= 12 ? hours : hours % 12;
    if( hours==0 ){
      hours = "12";
    }
    minutes = minutes < 10 ? "0" + minutes : minutes;
    return hours + ":" + minutes + " " + newFormat;
  };

  const toDateStr = (date) => {
    var days = date?.getUTCDay();
    var month = date?.getUTCMonth();
    var day = date?.getUTCDate();
    var year = date?.getUTCFullYear();

    if (days === 0) days = "Sunday";
    if (days === 1) days = "Monday";
    if (days === 2) days = "Tuesday";
    if (days === 3) days = "Wednesday";
    if (days === 4) days = "Thursday";
    if (days === 5) days = "Friday";
    if (days === 6) days = "Saturday";

    if (month === 0) month = "Janauary";
    if (month === 1) month = "Febuary";
    if (month === 2) month = "March";
    if (month === 3) month = "April";
    if (month === 4) month = "May";
    if (month === 5) month = "June";
    if (month === 6) month = "July";
    if (month === 7) month = "August";
    if (month === 8) month = "September";
    if (month === 9) month = "October";
    if (month === 10) month = "November";
    if (month === 11) month = "December";

    return days + ", " + month + " " + day + ", " + year;
  };

  const reserve = async () => {
    const body = {
      reservation_email: email,
      reservation_full_name: name,
      reservation_organization: org,
      reservation_title: title,
      session_id: appData.id,
      reservation_technical_needs: description
    };
    try {
      const response = await backendCall.post("/reserve_session", body);
      if (response.status === 200) {
        setGlobalMessage({
          severity: "success",
          content: "You have succesfully reserved a technical session",
        });
        setName("");
        setEmail("");
        setOrg("");
        setTitle("");
        setDescription("");
      }
    } catch (error) {
      console.log(error);
      setGlobalMessage({
        severity: "error",
        content:
          "Opps, something went wrong. Please select another session and reserve again.",
      });
    }
  };

  const reserveForm = (
    <Dialog fullWidth open={open} onClose={closeRevervation}>
      <DialogTitle>
        <IconButton
          onClick={closeRevervation}
          sx={{
            position: "absolute",
            left: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ my: 2, mx: 4 }}>
        <Grid container alignItems="center" justifyContent="center">
          {/* <Grid item xs={1}>
            <LoopIcon
              sx={{ color: (theme) => theme.palette.grey[500] }}
              fontSize="large"
            />
          </Grid> */}
          <Grid item xs={12}>
            <Typography variant="h6" fontSize={20} fontWeight="bold">
              {appData?.title}
            </Typography>
            <Typography>{toDateStr(appData?.startDate)}</Typography>
          </Grid>
          {/* <Grid item xs={1}>
            <AccessTimeIcon
              sx={{ color: (theme) => theme.palette.grey[500] }}
              fontSize="large"
            />
          </Grid> */}
          <Grid item xs={12}>
            <Typography>
              {to12HourFormat(appData?.startDate) +
                " ~ " +
                to12HourFormat(appData?.endDate)}
            </Typography>
          </Grid>
        </Grid>

        <TextField
          fullWidth
          size="small"
          variant="standard"
          margin="normal"
          label="Full Name"
          onChange={(event) => {
            setName(event.target.value);
          }}
          value={name}
        />
        <TextField
          fullWidth
          margin="normal"
          size="small"
          variant="standard"
          label="Email"
          onChange={(event) => {
            setEmail(event.target.value);
          }}
          value={email}
        />
        <TextField
          fullWidth
          size="small"
          variant="standard"
          margin="normal"
          label="Organization"
          onChange={(event) => {
            setOrg(event.target.value);
          }}
          value={org}
        />
        <TextField
          fullWidth
          size="small"
          variant="standard"
          margin="normal"
          label="Title"
          onChange={(event) => {
            setTitle(event.target.value);
          }}
          value={title}
        />
        <TextField
          fullWidth
          size="small"
          multiline
          rows={3}
          variant="standard"
          margin="normal"
          label="Please describe your technical assistance needs"
          onChange={(event) => {
            setDescription(event.target.value);
          }}
          value={description}
        />
        <Button variant="contained" sx={{ my: 1 }} onClick={reserve}>
          Reserve
        </Button>
      </DialogContent>
    </Dialog>
  );

  return (
    <>
      <HomeFrame currentPageName="1-Click Technical Assistance" />

      <Box className="content-body">

        <Typography>Request an one-on-one consultation with BAC technical experts and get your questions answered. Book an appointment now!! All times are in eastern time.</Typography>

        <Stack justifyContent="right" direction="row">
          <SquareIcon color="primary" sx={{ mx: 1 }} />
          <Typography align="center" variant="h5" sx={{ mb: 3 }}>
            Available
          </Typography>
          <SquareIcon color="disabled" sx={{ mx: 1 }} />
          <Typography align="center" variant="h5" sx={{ mb: 3 }}>
            Unavailable
          </Typography>
        </Stack>
        <Paper>
          <Scheduler data={appointments}>
            <ViewState defaultCurrentDate={moment().format("YYYY-MM-DD")} />
            <MonthView />
            <Appointments appointmentComponent={Appointment} />
            <Toolbar />
            <DateNavigator />
          </Scheduler>
        </Paper>

        {reserveForm}
      </Box>
      <Footer />
    </>
  );
}
